import { render, staticRenderFns } from "./ModalSuportePais.vue?vue&type=template&id=537e42a7&scoped=true"
import script from "./ModalSuportePais.vue?vue&type=script&lang=ts"
export * from "./ModalSuportePais.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuportePais.vue?vue&type=style&index=0&id=537e42a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e42a7",
  null
  
)

export default component.exports